(()=>{
  if(customElements.get('zb-mobile-atc'))return;
  class MobileAtc extends HTMLElement{
    connectedCallback(){
      if(this._bound)return;
      this._bound=true;
      this._button=this.querySelector('button');
      if(!this._button)return;
      this._refresh=()=>this.refresh();
      this._scroll=()=>{if(this._scrollFrame)return;this._scrollFrame=requestAnimationFrame(()=>{this._scrollFrame=null;this.sync();});};
      window.addEventListener('scroll',this._scroll,{passive:true});
      document.addEventListener('change',this._refresh);
      this.refresh();
    }
    refresh(){
      const main=document.getElementById(this.dataset.mainButtonId);
      if(!main){this.hidden=true;return;}
      if(main!==this._main){
        this._mutation?.disconnect();this._visibility?.disconnect();this._main=main;
        this._mutation=new MutationObserver(()=>this.sync());
        this._mutation.observe(main,{attributes:true,attributeFilter:['disabled','aria-disabled'],childList:true,subtree:true,characterData:true});
        if('IntersectionObserver' in window){
          this._visibility=new IntersectionObserver(([entry])=>{this.hidden=entry.isIntersecting;this._mode=entry.boundingClientRect.top>0?'choose':'add';this.sync();},{threshold:.15});
          this._visibility.observe(main);
        }else this.hidden=true;
      }
      this.sync();
    }
    sync(){
      if(!this._main||!this._button)return;
      this._mode=this._main.getBoundingClientRect().top>0?'choose':'add';
      this.dataset.mode=this._mode;
      this._button.disabled=this._main.disabled||this._main.getAttribute('aria-disabled')==='true';
      const label=(this._main.querySelector('span')?.textContent||this._main.textContent).trim();
      if(this._renderedLabel!==label){this._renderedLabel=label;this._button.textContent=label;}
    }
    disconnectedCallback(){
      this._mutation?.disconnect();this._visibility?.disconnect();
      window.removeEventListener('scroll',this._scroll);
      if(this._scrollFrame)cancelAnimationFrame(this._scrollFrame);
      document.removeEventListener('change',this._refresh);
      this._bound=false;this._main=null;
    }
  }
  customElements.define('zb-mobile-atc',MobileAtc);
})();

